import * as React from 'react';

import Box from '@mui/material/Box';
import type { BoxProps } from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';

export type StdDialogFormProps<C extends React.ElementType = 'form'> = {
  children?: React.ReactNode;
  component?: C;
  innerRef?: React.Ref<any>;
  sx?: SxProps<Theme>;
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void | Promise<unknown>;
} & Omit<BoxProps<C>, 'component' | 'sx' | 'onSubmit'>;

const StdDialogForm = <C extends React.ElementType = 'form'>({
  children,
  component,
  innerRef,
  sx: ferrySx,
  onSubmit,
  ...other
}: StdDialogFormProps<C>) => {
  return (
    <Box
      component={component ?? 'form'}
      display='flex'
      flex='1'
      flexDirection='column'
      onSubmit={onSubmit}
      ref={innerRef}
      sx={{ overflowY: 'auto', ...ferrySx }}
      {...other}
    >
      {children}
    </Box>
  );
};

export default StdDialogForm;
